import api from "../../../../services/api";

const BASE_URL = "/api/v1/novatra/marketplace";

const unwrap = (request) => request.then((response) => response.data?.data);
export const uploadListingImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/api/v1/novatra/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((response) => response.data);
};

export const materialMarketplaceApi = {
  uploadListingImage,
  getWorkflows: () => unwrap(api.get(`${BASE_URL}/workflows`)),
  createWorkflow: (payload) => unwrap(api.post(`${BASE_URL}/workflows`, payload)),
  setDefaultWorkflow: (id) => unwrap(api.post(`${BASE_URL}/workflows/${id}/default`)),
  createListing: (payload) => unwrap(api.post(`${BASE_URL}/material-listings`, payload)),
  updateListing: (id, payload) => unwrap(api.put(`${BASE_URL}/material-listings/${id}`, payload)),
  submitListing: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/material-listings/${id}/submit`, payload)),
  getListings: (params = {}) => unwrap(api.get(`${BASE_URL}/material-listings`, { params })),
  getListingById: (id) => unwrap(api.get(`${BASE_URL}/material-listings/${id}`)),

  getReviewWorklist: (params = {}) => unwrap(api.get(`${BASE_URL}/business/material-reviews`, { params: { page: 1, pageSize: 20, ...params } })).then((data) => Array.isArray(data) ? data : data.items || []),
  getReviewById: (id) => unwrap(api.get(`${BASE_URL}/business/material-reviews/${id}`)),
  verifyListing: (id, payload) => unwrap(api.post(`${BASE_URL}/business/material-reviews/${id}/verify`, payload)),
  requestClarification: (id, payload) => unwrap(api.post(`${BASE_URL}/business/material-reviews/${id}/request-clarification`, payload)),
  approveForNegotiation: (id, payload) => unwrap(api.post(`${BASE_URL}/business/material-reviews/${id}/approve-for-negotiation`, payload)),
  rejectListing: (id, payload) => unwrap(api.post(`${BASE_URL}/business/material-reviews/${id}/reject`, payload)),

  createNegotiation: (payload) => unwrap(api.post(`${BASE_URL}/negotiations`, payload)),
  getNegotiations: (params = {}) => unwrap(api.get(`${BASE_URL}/negotiations`, { params })),
  getNegotiation: (id) => unwrap(api.get(`${BASE_URL}/negotiations/${id}`)),
  createOffer: (id, payload) => unwrap(api.post(`${BASE_URL}/negotiations/${id}/offers`, payload)),
  acceptOffer: (id, offerId, payload = {}) => unwrap(api.post(`${BASE_URL}/negotiations/${id}/offers/${offerId}/accept`, payload)),
  rejectOffer: (id, offerId, payload = {}) => unwrap(api.post(`${BASE_URL}/negotiations/${id}/offers/${offerId}/reject`, payload)),

  getProcurementDeal: (id) => unwrap(api.get(`${BASE_URL}/procurement-deals/${id}`)),
  submitDealForApproval: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/procurement-deals/${id}/submit-for-approval`, payload)),
  approveDeal: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/procurement-deals/${id}/approve`, payload)),
  rejectDeal: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/procurement-deals/${id}/reject`, payload)),
  returnForNegotiation: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/procurement-deals/${id}/return-for-negotiation`, payload)),
  createPurchaseOrder: (id, payload = {}) => unwrap(api.post(`${BASE_URL}/procurement-deals/${id}/create-purchase-order`, payload)),
  getPurchaseOrder: (id) => unwrap(api.get(`${BASE_URL}/purchase-orders/${id}`)),
  createGoodsReceipt: (id, payload) => unwrap(api.post(`${BASE_URL}/purchase-orders/${id}/goods-receipt`, payload)),
  postGoodsReceiptToStock: (id) => unwrap(api.post(`${BASE_URL}/goods-receipts/${id}/post-stock`)),
};

export default materialMarketplaceApi;
